import useGoalsAccess from './features/useGoalsAccess'

export enum Features {
  GOALS
}

const useFeatures = (): Record<Features, boolean> => {
  const hasGoals = useGoalsAccess()

  return {
    [Features.GOALS]: hasGoals
  }
}

export default useFeatures
